import { BTIconFileImageFilled } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemDrawProps {
    fileId: number;
    onClick: () => Promise<void>;
}

const MenuItemSetAsMainPhoto = ({ fileId, onClick, ...antProps }: IMenuItemDrawProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`setAsMainPhoto-menuitem-${fileId}`}
            testid={`setAsMainPhoto-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconFileImageFilled /> Set as main photo
        </BTMenu.Item>
    );
};

export default MenuItemSetAsMainPhoto;
